<template>
    <v-dialog v-model="show" max-width="560">
        <v-card v-if="receiver">
            <v-card-title class="tit tit--xs">배송지 정보 수정</v-card-title>
            <v-card-text>
                <v-text-field v-model="receiver.name" label="수취인 이름" placeholder=" " hide-details />
                <v-text-field v-model="receiver.phone" label="수취인 연락처" placeholder=" " hide-details class="mt-4" />
                <v-text-field v-model="receiver.email" label="수취인 이메일" placeholder=" " hide-details class="mt-4" />
                <v-row align="center" class="mt-4">
                    <v-col cols="6" class="py-0">
                        <v-text-field v-model="shippingAddress.postcode" label="우편번호" placeholder=" " hide-details readonly @click="$refs.daumPostcode.open()" />
                    </v-col>
                    <v-col cols="auto" class="py-0 pl-0">
                        <v-btn color="primary" @click="$refs.daumPostcode.open()">주소검색</v-btn>
                    </v-col>
                </v-row>
                <v-text-field v-model="shippingAddress.address1" label="기본주소" placeholder=" " hide-details class="mt-4" readonly @click="$refs.daumPostcode.open()" />
                <v-text-field v-model="shippingAddress.address2" label="상세주소" placeholder=" " hide-details class="mt-4" />
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn text color="grey" @click="close">취소</v-btn>
                <v-btn text color="primary" @click="input">확인</v-btn>
            </v-card-actions>
        </v-card>
        <daum-postcode ref="daumPostcode" @input="({postcode, address}) => { shippingAddress.postcode = postcode; shippingAddress.address1 = address; } " />
    </v-dialog>
</template>
<script>
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
export default {
    components: {
        DaumPostcode
    },
    data(){
        return {
            show: false,
            receiver: null,
            shippingAddress: null
        }
    },
    methods: {
        init(){
            this.receiver = null;
            this.shippingAddress = null
        },
        open(){
            this.show = true;
        },
        con(data){
            console.log(data)
        },
        close(){
            this.show = false;
        },
        validate(){
            try{
                if(!this.receiver.name) throw new Error("수취인 이름을 입력해주세요");
                if(!this.receiver.phone) throw new Error("수취인 연락처를 입력해주세요");
                if(!this.receiver.email) throw new Error("수취인 이메일을 입력해주세요");
                if(!this.shippingAddress.postcode) throw new Error("우편번호를 입력해주세요");
                if(!this.shippingAddress.address1) throw new Error("배송지 주소를 입력해주세요");
                return true;
            }
            catch(error){
                alert(error.message);
                return false;
            }
        },
        async input(){
            if(this.validate()){
                this.$emit("input", { receiver: this.receiver, shippingAddress: this.shippingAddress });
                this.close();
            }
        }
    },
    watch: {
        show(){
            if(!this.show) this.init();
        }
    }
}
</script>